import {
  downloadImageAsBase64,
  getImageUrl,
  getSingle,
} from "@feelrobotics/strapi-sdk";

const PROMO_TYPE = "promo";

async function getPromotionBanner() {
  const searchString = "fp-promotional-banner";

  const res = await getSingle(searchString, PROMO_TYPE);

  if (res.error) {
    return res;
  }

  const formatted = {
    link: res.response["link"],
    tabletImg: await downloadImageAsBase64(getImageUrl(res.response, "tablet")),
    smallImg: await downloadImageAsBase64(getImageUrl(res.response, "small")),
    mediumImg: await downloadImageAsBase64(getImageUrl(res.response, "medium")),
  };
  res.response = formatted;
  return res;
}

export { getPromotionBanner };
